import { Link } from "react-router-dom";
import { useEffect } from "react";
import '../pages/home/home.css';

const CTA = () => {

    return (
        <div className="cta">
            <div className="container cta-container">
                <div className="cta-text-l">
                    <h5>NEED HELP?</h5> 
                    <p>Call us today to get free consultation.</p>
                    <h2>(+254) 708-746-461</h2> 
                    <p>Monday - Friday (08.00 AM - 05.00 PM)</p>
                </div>
                <div className="cta-text-r">
                    <h5>GET PROTECTION FROM PESTS</h5> 
                    <p>Let's start scheduling home visits.</p>
                    <span><Link to={"./contact"} className="btn sm cta-home-btn">Chat Us</Link></span>
                </div>
            </div>
        </div>
    )
}

export default CTA